export const showZipCode = (zipCode: string) => {
  const formatedValue = String(zipCode)
  if (formatedValue?.includes('-')) return zipCode
  return formatedValue.replace(/(\d{5})(\d{3})/, '$1-$2')
}
